import { getSupabase, houseTableMapping, stayTypeMapping } from './supabaseClient';
import { formatDateForAPI } from './bookingAPI';

// Fetch price for a specific booking
export const fetchPrice = async (houseKey, date, nights) => {
  try {
    const supabase = await getSupabase();
    if (!supabase) {
      throw new Error('Supabase client not initialized');
    }

    const tableName = houseTableMapping[houseKey];
    if (!tableName) {
      throw new Error('Invalid house key');
    }

    const stayType = stayTypeMapping[nights];
    if (!stayType) {
      throw new Error('Invalid nights value');
    }

    const dateStr = formatDateForAPI(date);

    const { data, error } = await supabase
      .from(tableName)
      .select('full_price')
      .eq('check_in_date', dateStr)
      .eq('stay_type', stayType)
      .eq('status', 'available')
      .eq('price_status', 'live')
      .single();

    if (error) {
      console.error('Error fetching price:', error);
      return null;
    }

    return data?.full_price || null;
  } catch (error) {
    console.error('Error in fetchPrice:', error);
    return null;
  }
};

// Format price for display
export const formatPrice = (price) => {
  if (price === null || price === undefined) {
    return 'Price not available';
  }
  
  // Ensure price is a number
  const numPrice = typeof price === 'string' ? parseFloat(price) : price;
  
  if (isNaN(numPrice)) {
    return 'Price not available';
  }
  
  return `£${numPrice.toFixed(2)}`;
};
